/* eslint-disable */
import { NEW_LEFT_COLOR, NEW_RIGHT_COLOR } from "utils/constant";
import "./footStrikeFoot.scss";

const FootStrikeCardFoot = (props) => {
  const { whichFoot, footData } = props;

  const checkHighest = (value) => {
    let testArr = [...Object.values(footData || {})];
    testArr = testArr.sort((a, b) => a - b);

    if (testArr.indexOf(value) === 0) {
      return 0.3;
    }

    if (testArr.indexOf(value) === 1) {
      return 0.6;
    }

    if (testArr.indexOf(value) === 2) {
      return 1;
    }
  };

	const calculatePercentage = (obj, value) => {
    const valuesArray = Object.values(obj || {});
    
    const totalSum = valuesArray.reduce((acc, curr) => acc + curr, 0);
    
    const percentage = (value / totalSum) * 100;
    
    return percentage.toFixed(1);
}

  const colours = {
    leftFoot: NEW_LEFT_COLOR,
    rigthFoot: NEW_RIGHT_COLOR,
  };

  if (whichFoot === "left") {
    return (
      <div className="foot_with_number_container">
        <div className="foot-segment" style={{justifyContent: "flex-end"}}>
          <div className="number_value">{calculatePercentage(footData, footData?.Front) + "%"}</div>
          <div className="line_separator"></div>
          <div className="foot_segment_svg">
            <TopAlternate
              width={30}
              fill={colours.leftFoot}
              stroke={colours.leftFoot}
              opacity={checkHighest(footData?.Front)}
            />
          </div>
        </div>
        <div className="foot-segment" style={{justifyContent: "flex-end"}}>
          <div className="number_value">{calculatePercentage(footData, footData?.Middle) + "%"}</div>
          <div className="line_separator"></div>
          <div className="foot_segment_svg">
            <MidAlternate
              width={30}
              fill={colours.leftFoot}
              stroke={colours.leftFoot}
              opacity={checkHighest(footData?.Middle)}
            />
          </div>
        </div>
        <div className="foot-segment" style={{justifyContent: "flex-end"}}>
          <div className="number_value">{calculatePercentage(footData, footData?.Back) + "%"}</div>
          <div className="line_separator"></div>
          <div className="foot_segment_svg">
            <BackAlternate
              width={30}
              fill={colours.leftFoot}
              stroke={colours.leftFoot}
              opacity={checkHighest(footData?.Back)}
            />
          </div>
        </div>
      </div>
    );
  } else if (whichFoot === "right") {
    return (
      <div className="foot_with_number_container">
        <div className="foot-segment" style={{justifyContent: "flex-start"}}>
          <div className="foot_segment_svg" style={{ transform: "scaleX(-1)" }}>
            <TopAlternate
              width={30}
              fill={colours.rigthFoot}
              stroke={colours.rigthFoot}
              opacity={checkHighest(footData?.Front)}
            />
          </div>
          <div className="line_separator"></div>
          <div className="number_value">{calculatePercentage(footData, footData?.Front) + "%"}</div>
        </div>
        <div className="foot-segment" style={{justifyContent: "flex-start"}}>
          <div className="foot_segment_svg" style={{ transform: "scaleX(-1)"}}>
            <MidAlternate
              width={30}
              fill={colours.rigthFoot}
              stroke={colours.rigthFoot}
              opacity={checkHighest(footData?.Middle)}
            />
          </div>
          <div className="line_separator"></div>
          <div className="number_value">{calculatePercentage(footData, footData?.Middle) + "%"}</div>
        </div>
        <div className="foot-segment" style={{justifyContent: "flex-start"}}>
          <div className="foot_segment_svg" style={{ transform: "scaleX(-1)"}}>
            <BackAlternate
              width={30}
              fill={colours.rigthFoot}
              stroke={colours.rigthFoot}
              opacity={checkHighest(footData?.Back)}
            />
          </div>
          <div className="line_separator"></div>
          <div className="number_value">{calculatePercentage(footData, footData?.Back) + "%"}</div>
        </div>
      </div>
    );
  }
};

const TopAlternate = (props) => {
  const {
    width = 110,
    fill = "blue",
    stroke = "none",
    strokeWidth = "10px",
    opacity = 1,
  } = props;
  return (
    <svg
      width={width}
      height={width}
      viewBox={`70 25 200 200`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // fill={fill}
        // stroke={stroke}
        // strokeWidth={strokeWidth}
        strokeOpacity={opacity}
        style={{
          fill: "white",
          stroke: fill,
          strokeWidth: strokeWidth,
          strokeMiterlimit: 6,
          paintOrder: "fill",
          fillOpacity: 0,
          width: "40px",
        }}
        d="M 166.585 178.692 C 206.72 170.397 240.476 173.178 240.476 173.178 C 243.089 125.374 242.26 92.87 225.251 66.416 C 225.251 66.416 214.762 51.554 206.14 47.292 C 195.629 42.096 182.516 39.827 171.053 42.293 C 159.45 44.789 148.419 51.133 139.724 59.211 C 124.38 73.466 114.142 92.905 105.89 112.155 C 97.627 131.43 91.197 152.277 90.852 173.246 C 90.669 184.345 93.44 206.507 93.44 206.507 C 93.44 206.507 135.543 185.107 166.585 178.692 Z"
      ></path>
    </svg>
  );
};

const MidAlternate = ({
  width = 100,
  fill = "blue",
  stroke = "none",
  strokeWidth = "10px",
  opacity = 1,
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox={`70 170 200 190`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeOpacity={opacity}
        style={{
          fill: "white",
          stroke: fill,
          strokeWidth: strokeWidth,
          strokeMiterlimit: 6,
          paintOrder: "fill",
          fillOpacity: 0,
          width: "40px",
        }}
        d="M 113.929 315.53 C 113.929 315.53 110.317 283.852 107.143 268.484 C 104.038 253.452 96.491 223.684 96.491 223.684 C 96.491 223.684 136.838 203.398 160.714 197.055 C 197.656 187.241 239.035 187.97 239.035 187.97 C 239.035 187.97 234.226 209.914 229.95 220.238 C 225.782 230.303 217.346 244.583 213.745 254.864 C 208.638 269.446 206.239 279.037 206.454 294.486 C 206.669 309.906 215.226 339.912 215.226 339.912 C 215.226 339.912 181.015 337.764 164.474 333.647 C 147.442 329.408 113.929 315.53 113.929 315.53 Z"
      ></path>
    </svg>
  );
};

const BackAlternate = ({
  width = 100,
  fill = "blue",
  stroke = "none",
  strokeWidth = "10px",
  opacity = 1,
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox={`70 320 190 180`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // fill={fill}
        // stroke={stroke}
        // strokeWidth={strokeWidth}
        strokeOpacity={opacity}
        style={{
          fill: "white",
          stroke: fill,
          strokeWidth: strokeWidth,
          strokeMiterlimit: 6,
          paintOrder: "fill",
          fillOpacity: 0,
          width: "40px",
        }}
        d="M 113.636 333.912 C 113.636 333.912 143.85 347.3 160.401 352.13 C 179.526 357.711 219.612 360.276 219.612 360.276 C 219.612 360.276 225.342 374.844 226.504 382.519 C 228.38 394.909 229.841 408.034 226.504 420.113 C 223.037 432.663 217.329 446.475 206.454 453.634 C 194.574 461.454 178.313 460.675 164.16 459.273 C 152.297 458.098 138.926 455.938 130.326 447.682 C 121.596 439.302 119.667 425.687 117.168 413.847 C 111.426 386.64 113.636 333.912 113.636 333.912 Z"
      ></path>
    </svg>
  );
};

export default FootStrikeCardFoot;
